<script setup lang="ts">
import { computed } from "vue"
import { isEmpty } from '~/helper'
enum TypeInspiration {
  Activity = 1,
  Country,
  Blog,
}

const props = defineProps({
  dataTrip: {
    type: Object,
    default: null,
  },
})
const activities = computed(() => {
  if (isEmpty(props.dataTrip)) return []
  return props.dataTrip.list_activities.concat(props.dataTrip.list_restaurants)
})
const blogs = computed(() => {
  if (isEmpty(props.dataTrip)) return []
  return props.dataTrip.list_blogs
})
const country = computed(() => {
  if (isEmpty(props.dataTrip)) return []
  return []
})
const destination = computed(() => {
  if (isEmpty(props.dataTrip)) return ''
  return props.dataTrip?.map_note?.destinations || ''
})
const inspirations = computed(() => [
  { id: TypeInspiration.Activity, name: `Explore the authentic activities in ${destination.value}`, items: activities.value },
  { id: TypeInspiration.Country, name: 'Explore nearby countries', items: country.value },
  { id: TypeInspiration.Blog, name: 'Explore the travel insights', items: blogs.value },
])
function mapRoute(link: string, type: TypeInspiration) {
  switch (type) {
    case TypeInspiration.Activity:
      return `/search-result?q=${link}`
    case TypeInspiration.Country:
      return `/search-result?q=${link}`
    case TypeInspiration.Blog:
      return link
  }
}
</script>

<template>
  <div class="py-40 flex flex-column grid-gap-20">
    <h2 class="heading-5-bd">Inspiration for you</h2>
    <template v-for="inspiration in inspirations" :key="inspiration.id">
      <div v-if="inspiration.items && inspiration.items.length" class="flex flex-column">
        <span class="text-md-sb">{{ inspiration.name }}</span>
        <p class="mb-0 mt-8 text-md-rg gray-700">
          <component
            :is="mapRoute(activity.link, inspiration.id).startsWith('http') ? 'a' : 'router-link'"
            v-for="(activity, idx) in inspiration.items"
            :key="idx"
            :href="mapRoute(activity.link, inspiration.id)"
            :to="mapRoute(activity.link, inspiration.id)"
            :target="mapRoute(activity.link, inspiration.id).startsWith('http') ? '_blank' : ''"
          >
            <span class="gray-700">{{ activity.name }}</span>
            <span v-if="idx < inspiration.items.length - 1" class="gray-700 ml-8 mr-8">|</span>
          </component>
        </p>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped></style>
